import { DBFactory } from "~/classes/database/db_factory";
import { BaseModel } from "../base.model";

type WordsToIgnoreConstructorParams = {
  id: string;
  words: string[];
};

export class WordsToIgnore extends BaseModel {
  id: string;
  words: string[];

  constructor({ id, words }: WordsToIgnoreConstructorParams) {
    super();

    this.id = id;
    this.words = words;

    this.modelDatabaseConfig = {
      collection: "/wordsToIgnore",
      path: `/wordsToIgnore/${this.id}`,
    };
  }

  // Override fromMap if you have special logic for creating an instance from a map
  static fromMap(map: any): WordsToIgnore {
    const instance = new WordsToIgnore(map);
    return instance;
  }

  async save() {
    const db = DBFactory.createDatabase();
    await db.save(this.toMap(), this.modelDatabaseConfig);
  }
}
